import * as yup from 'yup';
import moment from "moment";
import {MixCodesOriginFieldValidation} from '../EditPromotion/MixCodes/MixCodesCodeOriginValidation';

interface TestContextExtended {
    [key: string]: any;
}

const testStartEndDateRange = (value: any, compareWith: string | number, type: string, inUse: boolean): boolean => {

    if (inUse &&
        (
            (type === 'start' && moment(value).isBefore(moment(compareWith), 'day')) ||
            (type === 'end' && moment(value).isAfter(moment(compareWith), 'day'))
        )
    ) {
        return false;
    }

    return true;
}

const testPositiveNumber = (value: any, inUse: boolean): boolean => {
    if (inUse &&
        (!value
            || isNaN(parseInt(value))
            || typeof parseInt(value) !== 'number'
            || parseInt(value) < 0)
    ) {
        return false;
    }
    return true;
};
    const alphaNumaricRegex = /^[a-zA-Z0-9]{26}$/;
    const numericalRegex = /^\d{6,8}$/;

    const testMixCodesFields = (value: any, testContext: object) => {
    const { from } = testContext as yup.TestContext & TestContextExtended;
    let result = true;
    if (from[1].value.flow !== 'redeemPincodeForCurrencies') {
        return true;
    }
    if (from[1].value.proofType === 'receiptScanner') {
        return true;
    }
    if (from[1].value.tempParams.addRules === true) {
        if (value === undefined || value === null) {
            result = false;
        }
        if (!alphaNumaricRegex.test(value) && !numericalRegex.test(value)) {
            result = false;
        }
    }
  return result;
  }

function assignPromotionValidationSchema() {
    return yup.object({
        tempParams: yup.object().shape({
            pincodeOriginValitidy: yup.boolean(),
            flowOption: yup.string().required('Promotion mechanic has to be selected'),
            startDateTime: yup.date().required()
                .test('startDateTest', 'Promotion start date cannot be earlier than the campaign start date',
                    (value, testContext) => {
                        const { from } = testContext as yup.TestContext & TestContextExtended
                        let result = true;
                        if (moment(from[1].value.configurationParameters.configurationStartUtc).isAfter(moment(value), 'minute')) {
                            result = false
                        }
                        return result
                    })
                .test('startDateTest', 'Promotion start date cannot be in the past',
                    (value) => {
                        let result = true;
                        let date = new Date();
                        if (moment(value).isBefore(date, 'minute')) {
                            result = false
                        }
                        return result
                    }),
            endDateTime: yup.date().required()
                .test('endDateTest', 'Promotion end date cannot be later than the campaign end date',
                    (value, testContext) => {
                        const { from } = testContext as yup.TestContext & TestContextExtended
                        let result = true;
                        if (moment(from[1].value.configurationParameters.configurationEndUtc).isBefore(moment(value), 'minute')) {
                            result = false
                        }
                        return result
                    }),
            currencyNames: yup.array().required().test('c&g and auto c&g currency test', 'At least one currency must be selected',
                (value, testContext) => {
                    const flowOption = (testContext.parent as { flowOption?: string } | undefined)?.flowOption;
                    const selectedCurrencies = Array.isArray(value) ? value.filter(Boolean) : [];
                    if ((flowOption === "Collect & Get" || flowOption === "Auto Collect & Get") && selectedCurrencies.length < 1) {
                        return false;
                    }
                    return true;
                }),
            leaderboadCurrencyNames: yup.array().of(yup.string())
                .when('enableLeaderboard', {
                    is: true,
                    then: yup.array().min(1, 'At least one currency must be selected'),
                    otherwise: yup.array().notRequired()
                }),
            codeType: yup.array().of(yup.string()).default(() => []),
                       luckyNumbersBatchSize: yup.mixed().test(
                'luckyNumbersBatchSizeTest',
                'Batch size must be an integer between 1 and 100000',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    const flow = from[0]?.value?.flowOption;
                    if (flow !== 'Lucky Numbers' && flow !== 'luckyNumbers') {
                        return true;
                    }
                    if (!/^\d+$/.test(value)) {
                        return false;
                    }
                    const n = parseInt(value, 10);
                    return n >= 1 && n <= 100000;
                }
            ),

            luckyNumbersBatchAmount: yup.mixed().test(
                'luckyNumbersBatchAmountTest',
                'Batch amount must be an integer between 1 and 100.',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    const flow = from[0]?.value?.flowOption;
                    if (flow !== 'Lucky Numbers' && flow !== 'luckyNumbers') {
                        return true;
                    }
                    if (!/^\d+$/.test(value)) {
                        return false;
                    }
                    const n = parseInt(value, 10);
                    return n >= 1 && n <= 100;
                }
            ),
        }),
        params: yup.object(
            {
                campaignIds: yup.array().of(yup.string()).default(() => ['']),
                lotIds: yup.array().of(yup.string()).default(() => ['']),
            }).shape({
            reduceAmount: yup.mixed()
                .test('reduceAmountTest', 'Currency has to be selected',
                    (value, testContext) => {
                        const { from } = testContext as yup.TestContext & TestContextExtended
                        const useCurrency = Boolean(from?.[1]?.value?.tempParams?.useCurrency);
                        let result = true;
                        value && value.forEach((element: { currencyId: string, amount: string }) => {
                            if (useCurrency && (!element.currencyId || !element.currencyId.trim())) {
                                result = false
                            }
                        })
                        return result
                    })
                .test('reduceAmountTest', 'Cost must be a positive number',
                    (value, testContext) => {
                        const { from } = testContext as yup.TestContext & TestContextExtended
                        const useCurrency = Boolean(from?.[1]?.value?.tempParams?.useCurrency);
                        let result = true;
                        value && value.forEach((element: { currencyId: string, amount: string }) => {
                            if (useCurrency && (!(/^\d+$/.test(element.amount)) || (Number(element.amount) <= 0))) {
                                result = false
                            }
                        })
                        return result
                    }),
        }),
        leaderboard: yup.object().shape({
            expiresAt: yup.number().test(
                'expiresAt required test',
                'Expiration date is required',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    let result = true;
                    if (from[1].value.tempParams.enableLeaderboard && !value) {
                        result = false;
                    }
                    return result
                })
            }),
        pluginParams: yup.object().shape({
            emailTemplateId: yup.string().test(
                'emailTemplateId required test',
                'emailTemplateId is required',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    let result = true;
                    if (from[1].value?.proofType !== 'receiptScanner') {
                        return true;
                    }
                    if (!value) {
                        result = false;
                    }
                    return result
                }
            ),
            rejectedEmailTemplateId: yup.string().test(
                'rejectedEmailTemplateId required test',
                'rejectedEmailTemplateId is required',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    let result = true;
                    if (from[1].value?.proofType !== 'receiptScanner') {
                        return true;
                    }
                    if (!value) {
                        result = false;
                    }
                    return result
                }
            ),
            url: yup.object().test(
            'url required test',
            'url is required',
            function (value, testContext)  {
            const { from } = testContext as yup.TestContext & TestContextExtended;// Extract "from" to check conditions
                if (from[2]?.value?.proofType === 'receiptScanner') {
                // Check if the URL object is empty or has undefined values
                if (
                    !value ||
                    (typeof value === 'object' && Object.keys(value).length === 0) ||
                    Object.values(value).some(v => v === undefined)
                ) {
                    return this.createError({
                    message: 'URL object cannot be empty',
                    path: 'pluginParams.url',
                    });
                }

                // Check each URL for validity
                const urlValidationResults = Object.entries(value).map(([key, url]) => {
                    if (url && typeof url === 'string') {

                    if (!/^https?:\/\/[^ ]+$/i.test(url)) {
                        return this.createError({
                        message: `Invalid URL for key ${key}`,
                        path: 'pluginParams.url',
                        });
                    }
                    } else {
                    return this.createError({
                        message: `URL for key ${key} is required and cannot be empty`,
                        path: 'pluginParams.url',
                    });
                    }
                    return null;
                }).filter(error => error);

                if (urlValidationResults.length > 0) {
                    return urlValidationResults[0];
                }

                }

                return true;
            }
        )

        }),
        pluginRoutes: yup.object().shape({
            processReceipts: yup.object().shape({
                externalReqParams: yup.object().shape({
                    scannerConfigInstanceId: yup.string().test(
                        'scannerConfigInstanceId required test',
                        'scannerConfigInstanceId is required',
                        (value, testContext) => {
                            const { from } = testContext as yup.TestContext & TestContextExtended;
                            let result = true;
                            if (from[3].value?.proofType !== 'receiptScanner') {
                                return true;
                            }
                            if (!value) {
                                result = false;
                            }
                            return result
                        }
                    ),
                    timeoutInMillis: yup.number().test(
                        'timeoutInMillis required test',
                        'timeoutInMillis is required',
                        (value, testContext) => {
                            const { from } = testContext as yup.TestContext & TestContextExtended;
                            let result = true;
                            if (from[3].value?.proofType !== 'receiptScanner') {
                                return true;
                            }
                            if (!value) {
                                result = false;
                            }
                            return result
                        }
                    )
                })
            })
        }),
        secrets: yup.object().shape({
            mixCodesParameters: yup.mixed()
                .test('mixcodesTest',
                    'If functionality is applied, mixcodes details are required',
                    (value, testContext) => {
                        const { from } = testContext as yup.TestContext & TestContextExtended
                        let result = true;
                        if (from[1].value.proofType !== 'mixCodes') {
                                return true;
                        }
                        value && value.forEach((element: { programId: string, secret: string, uri: string }) => {
                            if ((element.programId === undefined || element.secret === undefined || element.uri === undefined)) {
                                result = false
                            }
                        });
                        return result
                    })
                .test('programIdTest',
                    'Program Id must be alphanumeric characters of 26 or numeric of 6-8',
                        (value, testContext) => {
                            const { from } = testContext as yup.TestContext & TestContextExtended;
                            let result = true;
                            if (from[1].value.proofType !== 'mixCodes') {
                                return true;
                            }
                            if (value) {
                            value.forEach((element: { programId: string, secret: string, uri: string }) => {
                                if (
                                element.programId !== undefined &&
                                !(alphaNumaricRegex.test(element.programId) || numericalRegex.test(element.programId))) {
                                result = false;
                                }
                            });
                            }
                            return result;
                        }
                        ),
        }
        ),
        configurationParameters: yup.object({
            additionalInformation: yup.object({
                name: yup
                    .string()
                    .max(90, 'The maximum length of the campaign name is 90 characters')
                    .required('Promotion name cannot be empty'),
            }),
            country: yup
                .string()
                .required('Market has to be selected'),
            language: yup
                .string()
                .required('Language has to be selected'),
            captchaDetails: yup
                .object().shape({
                    projectId: yup.string().test('captchatest', 'If option is selected, project id must be provided',
                        (value, context: yup.TestContext & TestContextExtended) => {
                            const { from } = context
                            if (from[2].value.tempParams.addCaptcha && (!value || value === '')) {
                                return false
                            }
                            return true
                        }),
                    siteKey: yup.string().test('captchatest', 'If option is selected, site key must be provided',
                        (value, context: yup.TestContext & TestContextExtended) => {
                            const { from } = context
                            if (from[2].value.tempParams.addCaptcha && (!value || value === '')) {
                                return false
                            }
                            return true
                        }),
                })
        }),
        participationLimits: yup.object().shape({
            participationLifetimeLimit: yup.mixed().test('participationLifetimeLimitTest',
                'This information is required if option is selected and should be a positive number',
                (value, context: yup.TestContext & TestContextExtended) => testPositiveNumber(value, context.from[1].value.tempParams.limits.lifetime)
            ),
            participationLimit: yup.mixed().test('participationLimitTest',
                'This information is required if option is selected and should be a positive number',
                (value, context: yup.TestContext & TestContextExtended) => testPositiveNumber(value, context.from[1].value.tempParams.limits.rolling)
            ),
            participationLimitTime: yup.mixed()
                .test('participationLimitTimeTest',
                    'This information is required if option is selected and should be a positive number',
                    (value, context: yup.TestContext & TestContextExtended) => testPositiveNumber(value, context.from[1].value.tempParams.limits.rolling)
                ),
            participationLimitCalendarDatesLimit: yup.mixed().test('participationLimitCalendarDatesLimitTest',
                'This information is required if option is selected and should be a positive number',
                (value, context: yup.TestContext & TestContextExtended) => testPositiveNumber(value, context.from[1].value.tempParams.limits.calendarDay)
            ),
            participationLimitCalendarDatesRange: yup.object({
                startDate: yup.mixed()
                    .test('participationLimitCalendarDatesRange-startDate',
                        "Selected dates can't be in the past or after the promotion end",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[2].value.tempParams[`startDateTime`], 'start', context.from[2].value.tempParams.limits.calendarDay)
                    )
                    .test('participationLimitCalendarDatesRange-startDate-after-end',
                        "Selected date cannot be after end date",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[0].value.endDate, 'end', context.from[2].value.tempParams.limits.calendarDay)

                    ),
                endDate: yup.mixed()
                    .test('participationLimitCalendarDatesRange-endDate',
                        "Selected dates can't be in the past or after the promotion end",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[2].value.tempParams[`endDateTime`], 'end', context.from[2].value.tempParams.limits.calendarDay)
                    )
                    .test('participationLimitCalendarDatesRange-endDate-before-start',
                        "Selected date cannot be before start date",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[0].value.startDate, 'start', context.from[2].value.tempParams.limits.calendarDay)
                    ),
            }),
            participationLimitStartEndDatesRange: yup.object({
                startDate: yup.mixed()
                    .test('participationLimitStartEndDatesRange-startDate',
                        "Selected dates can't be in the past or after the promotion end",
                        (value, context: yup.TestContext & TestContextExtended) => {
                            return testStartEndDateRange(value, context.from[2].value.tempParams[`startDateTime`], 'start', context.from[2].value.tempParams.limits.useRollingCustomDuration)
                        }
                    )
                    .test("participationLimitStartEndDatesRange-startDate-after-end",
                        "Selected date cannot be after end date",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[0].value.endDate, 'end', context.from[2].value.tempParams.limits.useRollingCustomDuration)
                    ),
                endDate: yup.mixed()
                    .test('participationLimitStartEndDatesRange-endDate',
                        "Selected dates can't be in the past or after the promotion end",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[2].value.tempParams[`endDateTime`], 'end', context.from[2].value.tempParams.limits.useRollingCustomDuration)
                    )
                    .test("participationLimitStartEndDatesRange-endDate-before-start",
                        "Selected date cannot be before start date",
                        (value, context: yup.TestContext & TestContextExtended) => testStartEndDateRange(value, context.from[0].value.startDate, 'start', context.from[2].value.tempParams.limits.useRollingCustomDuration)
                    ),
            }),
            minAge: yup.mixed()
                .test('minAgeTest',
                    'Minimum age must be a positive integer from 1 to 120 only',
                    (value, testContext) => {
                        const { from } = testContext as yup.TestContext & TestContextExtended;
                        const limit = from[1].value.tempParams.limits.minAge;

                        if (limit && (
                            !(/^\d+$/.test(value))
                            || parseInt(value) <= 0
                            || parseInt(value) > 120)
                        ) {
                            return false;
                        }

                        return true;
                    })
        }),
        allocationRules: yup.array().of(
            yup.object().shape({
                currencyName: yup.string()
                    .test('currencyNameTest', "Currency has to be selected",
                        (value, testContext) => {
                            const { from } = testContext as yup.TestContext & TestContextExtended;
                            if (from[1].value.flow !== 'redeemPincodeForCurrencies') {
                                return true;
                            }
                            let result = true;
                            if (value === undefined && from[1].value.tempParams.addRules === true) {
                                result = false
                            }
                            return result
                        }),
                SKU: yup.string()
                    .test('SKUTest', "SKU must be selected",
                        (value, testContext) => {
                            const { from } = testContext as yup.TestContext & TestContextExtended;
                            if (from[1].value.proofType !== 'receiptScanner' || from[1].value.flow !== 'redeemPincodeForCurrencies') {
                                return true;
                            }
                            let result = true;
                            if (value === undefined) {
                                result = false
                            }
                            return result
                        }),
                programId: yup.string()
                    .test('programIdTest', "Program Id must be alphanumeric characters of 26 or numeric of 6-8", testMixCodesFields),
                lotId: yup.string()
                    .test('lotIdTest', "Lot or Campagin Id must be alphanumeric characters of 26 or numeric of 6-8", testMixCodesFields),
                amount: yup.mixed()
                    .test('amountTest', 'Only a positive integer can be entered. No letters, special characters, or spaces',
                        (value, testContext) => {
                            const { from } = testContext as yup.TestContext & TestContextExtended;
                            if (from[1].value.flow !== 'redeemPincodeForCurrencies') {
                                return true;
                            }
                            let result = true;
                            if (from[1].value.tempParams.addRules === true && !/^[1-9]\d*$/.test(String(value))) {
                                result = false
                            }
                            return result
                        }),
            })
        ),
        referralRewards: yup.object().shape({
              referrer: yup.object()
                .default({})
                .shape({
                  currency: yup.string().test(
                    'Referrer box Currency test',
                    'Please select a Currency to be awarded to the referrer',
                    (value, testContext) => {
                      const fromTestCtx: any = testContext;
                      let currentState = fromTestCtx?.from[2]?.value;
                      let result = true;
                      if (currentState?.referrerBox && !currentState?.referralRewards?.referrer?.currency) {
                        result = false;
                      }
                      return result;
                    }
                  ),
                  amount: yup.number()
                    .test('Referrer Box Currency amount test', 'Please type in an amount between 1 and 9999 to be awarded to the referrer', (value, testContext) => {
                      const fromTestCtx: any = testContext;
                      let currentState = fromTestCtx?.from[2]?.value;
                      let result = true;
                      if (currentState?.referrerBox && (currentState?.referralRewards?.referrer?.amount === 0  || currentState?.referralRewards?.referrer?.amount > 9999 || !currentState?.referralRewards?.referrer?.amount)) {
                        result = false;
                      }
                      return result;
                    })
                }),
            referee: yup.object()
                .default({})
                .shape({
                  currency: yup.string().test(
                    'Referee box Currency test',
                    'Please select a Currency to be awarded to the referee',
                    (value, testContext) => {
                      const fromTestCtx: any = testContext;
                      let currentState = fromTestCtx?.from[2]?.value;
                      let result = true;
                      if (currentState?.refereeBox && !currentState?.referralRewards?.referee?.currency) {
                        result = false;
                      }
                      return result;
                    }
                  ),
                  amount: yup.number()
                    .test('Referee Box Currency amount test', 'Please type in an amount between 1 and 9999 to be awarded to the referee', (value, testContext) => {
                      const fromTestCtx: any = testContext;
                      let currentState = fromTestCtx?.from[2]?.value;
                      let result = true;
                      if (currentState?.refereeBox && (currentState?.referralRewards?.referee?.amount === 0  || currentState?.referralRewards?.referee?.amount > 9999 || !currentState?.referralRewards?.referee?.amount)) {
                        result = false;
                      }
                      return result;
                    })
                }),
            emailTemplateId: yup.string()
                .test(
                    'Email template required check',
                    'Please enter a template name',
                    (value, testContext) => {
                        const fromTestCtx: any = testContext;
                        const currentState = fromTestCtx?.from[1]?.value?.referralRewards;
                        let result = true;
                        if ((currentState?.referee?.sendEmail || currentState?.referrer?.sendEmail) && !currentState.emailTemplateId) {
                        result = false;
                        }
                        return result;
                    }
                )
        }),
        maxParticipationIds: yup.number()
            .nullable(true)
            .max(100)
            .min(1)
            .label('Maximum vouchers')
    })
    .test('validate-campaign-lot', function (values) {

        const valResult = MixCodesOriginFieldValidation(values);

        if (valResult.isValid) {
            return true;
        }

        if ('message' in valResult) {
            return this.createError({
                path: valResult.path,
                message: valResult.message,
            });
        }

    })
}

export { assignPromotionValidationSchema }
